import { EngineSizeRange, engineSizeRangesData } from '@cinch-nx/data-search'
import { findSelectedOptionLabel } from './utils'

export function stringifyEngineSizeReferenceDataValue(
  engineSizesReferenceData: EngineSizeRange[],
  key: 'min' | 'max',
) {
  return engineSizesReferenceData.map((option) => ({
    value: option[key].toString(),
    label: option.label,
  }))
}

const getFormattedFromEngineSizeCc = (engineSizeCcSelection = -1) => {
  if (engineSizeCcSelection === -1) return ''
  return `From ${findSelectedOptionLabel(
    stringifyEngineSizeReferenceDataValue(engineSizeRangesData, 'min'),
    engineSizeCcSelection.toString(),
  )}`
}
export const getFormattedToEngineSizeCc = (engineSizeCcSelection = -1) => {
  if (engineSizeCcSelection === -1) return ''
  return `To ${findSelectedOptionLabel(
    stringifyEngineSizeReferenceDataValue(engineSizeRangesData, 'max'),
    engineSizeCcSelection.toString(),
  )}`
}
export const getFormattedEngineSizeCcRange = (
  fromEngineSizeCcSelection = -1,
  toEngineSizeCcSelection = -1,
) => {
  if (fromEngineSizeCcSelection === -1 && toEngineSizeCcSelection === -1)
    return ''

  const fromEngineSizeCc = getFormattedFromEngineSizeCc(
    fromEngineSizeCcSelection,
  )
  let toEngineSizeCc = getFormattedToEngineSizeCc(toEngineSizeCcSelection)

  if (fromEngineSizeCc) {
    toEngineSizeCc = ` ${toEngineSizeCc.toLowerCase()}`
  }

  return `${fromEngineSizeCc}${toEngineSizeCc}`.trim()
}
